<template>
  <div class="divide-y divide-gray-200">
    <div class="px-4 py-3 sm:px-6 sm:py-4">
      <MetricChartQueryBuilder @query="loadData" />
    </div>
    <div v-if="loading" class="p-12 text-center">
      <Loader />
    </div>
    <template v-else-if="insights && insights.length">
      <div v-for="insight in insights" :key="insight.id" class="divide-y divide-gray-200">
        <div class="px-4 py-3 sm:px-6 sm:py-4">
          <h3 class="text-lg font-medium">
            {{ insight.title }}
          </h3>
          <p class="text-gray-600 text-sm">
            {{ insight.description }}
          </p>
        </div>
        <div class="px-4 py-3 sm:px-6 sm:py-4">
          <AreaChart :values="getValues(insight.values)" :metric="metric" />
          <h4 class="text-base font-medium text-center mt-10 mb-4">
            Facebook Campaigns Active By Day
          </h4>
          <TimelineChart :data="facebookCampaignInsights" :range="[query.since, query.until]" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import {
  accountFacebookCampaignReportsClient,
  accountFacebookPageInstagramInsightsClient,
} from '@/api/clients';
import { DAY } from '@/utils/instagram-insights-query-params';
import convertReportDataToTimelineChartData from '@/utils/convert-report-data-to-timeline-chart-data';
import MetricChartQueryBuilder from './metric-chart-query-builder.vue';
import AreaChart from './area-chart.vue';
import TimelineChart from './timeline-chart.vue';

export default {
  components: {
    MetricChartQueryBuilder,
    AreaChart,
    TimelineChart,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    facebookPageId: {
      type: String,
      required: true,
    },
    metric: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      insights: null,
      facebookCampaignInsights: null,
      rejectReason: null,
      query: null,
    };
  },
  methods: {
    async loadData(query) {
      this.query = query;
      try {
        this.loading = true;

        await Promise.all([this.loadInsights(), this.loadFacebookCampaignInsights()]);
      } catch (error) {
        this.rejectReason = error.message;
      } finally {
        this.loading = false;
      }
    },
    async loadInsights() {
      try {
        const response = await accountFacebookPageInstagramInsightsClient.read(
          this.accountId,
          this.facebookPageId,
          {
            metric: this.metric.name,
            period: DAY,
            since: this.query.since,
            until: this.query.until,
          }
        );

        this.insights = response.data;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async loadFacebookCampaignInsights() {
      try {
        const response = await accountFacebookCampaignReportsClient.list(this.accountId, {
          filter: {
            date_between: `${this.query.since},${this.query.until}`,
          },
          fields: {
            facebook_reports: 'id,date_from,facebook_campaign_id',
          },
        });

        this.facebookCampaignInsights = convertReportDataToTimelineChartData(response.data);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getValues(rawValues) {
      return rawValues.map((rawValue) => ({
        date: moment(rawValue.end_time).format('YYYY-MM-DD'),
        value: rawValue.value,
      }));
    },
    getTotalRows(obj) {
      return Object.keys(obj).length;
    },
    getHumanReadableDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
};
</script>
